"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  LegalScale1: ['legal-scale-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 23.25L12 5.25', 'M7.5 23.25L16.5 23.25', 'M13.5 3.75L18.75 3.75', 'M5.25 3.75L10.5 3.75', 'M10.500 3.750 A1.500 1.500 0 1 0 13.500 3.750 A1.500 1.500 0 1 0 10.500 3.750 Z', 'M9,14.25a3.75,3.75,0,0,1-7.5,0Z', 'M5.25 3.75L1.5 11.25', 'M5.25 3.75L9 11.25', 'M22.5,14.25a3.75,3.75,0,0,1-7.5,0Z', 'M18.75 3.75L15 11.25', 'M18.75 3.75L22.5 11.25']],
  LegalScale: ['legal-scale', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.222,22.592a.465.465,0,0,1-.075.45.563.563,0,0,1-.443.208H7.3a.563.563,0,0,1-.443-.208.465.465,0,0,1-.075-.45L7.285,21.2a1.511,1.511,0,0,1,1.438-.949h6.554a1.511,1.511,0,0,1,1.438.949Z', 'M9.75,20.25V19.217A2.123,2.123,0,0,1,12,17.25a2.123,2.123,0,0,1,2.25,1.967V20.25', 'M12 17.239L12 6', 'M13.843,4.227a1.823,1.823,0,0,1-3.645,0A10.865,10.865,0,0,1,11.481,1.07a.615.615,0,0,1,1.079,0A10.893,10.893,0,0,1,13.843,4.227Z', 'M2.25 7.5L21.75 7.5', 'M4.5 7.5L4.5 12', 'M7.777,12a.474.474,0,0,1,.357.162.462.462,0,0,1,.111.373,3.789,3.789,0,0,1-7.49,0,.464.464,0,0,1,.111-.374A.477.477,0,0,1,1.224,12Z', 'M19.5 7.5L19.5 12', 'M22.777,12a.474.474,0,0,1,.357.162.462.462,0,0,1,.111.373,3.789,3.789,0,0,1-7.49,0,.464.464,0,0,1,.111-.374A.477.477,0,0,1,16.224,12Z']],
  LegalScaleUnequal: ['legal-scale-unequal', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 23.25L12 5.25', 'M7.5 23.25L16.5 23.25', 'M13.227 2.887L20.25 0.75', 'M3 6L10.491 3.72', 'M10.500 3.750 A1.500 1.500 0 1 0 13.500 3.750 A1.500 1.500 0 1 0 10.500 3.750 Z', 'M9,15.75a3.75,3.75,0,0,1-7.5,0Z', 'M5.212 5.327L1.5 12.75', 'M5.278 5.307L9 12.75', 'M22.5,11.25a3.75,3.75,0,0,1-7.5,0Z', 'M18.481 1.289L15 8.25', 'M22.5,8.25l-3.552-7.1']],
  LegalScaleUnequal1: ['legal-scale-unequal-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 4.33L12 23.25', 'M0.75 17.114L4.33 9.479 7.909 17.114', 'M4.33,20.693a3.494,3.494,0,0,0,3.579-3.579H.75A3.494,3.494,0,0,0,4.33,20.693Z', 'M23.25 10.977L19.67 3.272 16.091 10.977', 'M19.67,14.557a3.494,3.494,0,0,1-3.579-3.58H23.25A3.494,3.494,0,0,1,19.67,14.557Z', 'M2.229 10.328L20.752 2.772', 'M7.398 23.25L11.489 23.25 16.602 23.25 9.443 23.25']],
  LegalHammer: ['legal-hammer', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.27,8.612,22.6,17.406a1.309,1.309,0,0,1,0,1.852l-.926.925a1.307,1.307,0,0,1-1.851,0l-8.794-9.325', 'M3.58,8.575a19.034,19.034,0,0,0,7.407-7.407,1.307,1.307,0,0,1,1.851,0l3.51,3.51a1.307,1.307,0,0,1,0,1.851,18.119,18.119,0,0,0-7.407,7.407,1.309,1.309,0,0,1-1.852,0L3.58,10.427A1.309,1.309,0,0,1,3.58,8.575Z', 'M12.75,21.75h0a1.5,1.5,0,0,0-1.5-1.5H3.75a1.5,1.5,0,0,0-1.5,1.5h0v1.5h10.5Z', 'M0.75 23.25L14.25 23.25']],
  LegalScale2: ['legal-scale-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.5 6L22.5 6', 'M2.25 18L6 6 9.75 18', 'M10.5,18a4.5,4.5,0,0,1-9,0Z', 'M14.25 18L18 6 21.75 18', 'M22.5,18a4.5,4.5,0,0,1-9,0Z', 'M12 6L12 1.5']]
};
exports["default"] = _default;